import { render, staticRenderFns } from "./text-record.vue?vue&type=template&id=771cd944&scoped=true&"
import script from "./text-record.vue?vue&type=script&lang=js&"
export * from "./text-record.vue?vue&type=script&lang=js&"
import style0 from "./text-record.vue?vue&type=style&index=0&id=771cd944&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "771cd944",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/98-prod-frontend-deploy-tke/mgr-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('771cd944')) {
      api.createRecord('771cd944', component.options)
    } else {
      api.reload('771cd944', component.options)
    }
    module.hot.accept("./text-record.vue?vue&type=template&id=771cd944&scoped=true&", function () {
      api.rerender('771cd944', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/chatLog/lib/text-record.vue"
export default component.exports